import { render } from "./KSEmptyTrash.vue?vue&type=template&id=3a6d9680"
import script from "./KSEmptyTrash.vue?vue&type=script&lang=js"
export * from "./KSEmptyTrash.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__